import React, { useEffect, useState, useMemo } from "react";
import { useUI } from "../../context/UIContext";
import { ReportAPI } from "../../api/apiClient";

interface EquipmentLatestPlantInDto {
  component: string | null;
  date: string;
  quantity: number;
  unit: string | null;
}

export default function StatementEquipmentLatestPlantInReport() {
  const { selectedProjectId } = useUI();

  const [data, setData] = useState<EquipmentLatestPlantInDto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedProjectId) return;
    loadReport();
  }, [selectedProjectId]);

  const loadReport = async () => {
    try {
      setLoading(true);

      const result =
        await ReportAPI.getEquipmentLatestPlantInDashboard({
          project: selectedProjectId!,
          vendor: -1,
          cmp: 0,
        });

      setData(result);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* GROUPING LOGIC */
  const groupedData = useMemo(() => {
    if (!data || data.length === 0) return [];

    const grouped: Record<string, EquipmentLatestPlantInDto[]> = {};

    data.forEach((item) => {
      const key = item.component ?? "Unknown";
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(item);
    });

    return Object.entries(grouped).map(([component, items]) => {
      const totalQuantity = items.reduce(
        (sum, item) => sum + item.quantity,
        0
      );

      const latestDate = items
        .map((i) => new Date(i.date))
        .sort((a, b) => b.getTime() - a.getTime())[0];

      return {
        component,
        quantity: totalQuantity,
        unit: items[0].unit,
        date: latestDate,
      };
    });
  }, [data]);

 {/* return (
    <div className="bg-gray-100 p-6 rounded-xl">

      {loading && (
        <div className="text-center text-gray-600">Loading...</div>
      )}

      {!loading &&
        groupedData.map((item, index) => (
          <div
            key={index}
            className="max-w-md mx-auto bg-white shadow rounded-lg mb-6 overflow-hidden"
          >
            <div className="bg-blue-700 text-white px-4 py-2 font-semibold text-sm">
              RECENT PLANT-IN
            </div>

            <div className="p-4">
              <div className="flex justify-between items-start">
                <div className="text-gray-800 font-medium leading-snug">
                  {item.component}
                </div>

                <div className="text-sm text-gray-600 whitespace-nowrap">
                  {item.date.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "2-digit",
                  })}
                </div>
              </div>

              <div className="text-center mt-4 text-lg font-semibold text-gray-700">
                {item.quantity.toFixed(2)} {item.unit}
              </div>
            </div>

            <div className="h-1 bg-green-700"></div>
          </div>
        ))}

      {!loading && groupedData.length === 0 && (
        <div className="text-center text-gray-500">
          No records found
        </div>
      )}
    </div>
  );
}
*/}

/*return (
  <div className="flex justify-center">

    {loading && (
      <div className="text-center text-gray-600">Loading...</div>
    )}

    {!loading &&
      groupedData.map((item, index) => (
        <div
          key={index}
          className="w-full max-w-md bg-white shadow-md rounded-lg overflow-hidden"
        >
          
          <div className="bg-blue-700 text-white px-4 py-2 font-semibold text-sm">
            RECENT PLANT-IN
          </div>

         
          <div className="p-4">
            <div className="flex justify-between items-start">
              <div className="text-gray-800 font-medium leading-snug">
                {item.component}
              </div>

              <div className="text-sm text-gray-600 whitespace-nowrap">
                {item.date.toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "2-digit",
                })}
              </div>
            </div>

            <div className="text-center mt-4 text-lg font-semibold text-gray-700">
              {item.quantity.toFixed(2)} {item.unit}
            </div>
          </div>

         
        </div>
      ))}

    {!loading && groupedData.length === 0 && (
      <div className="text-center text-gray-500">
        No records found
      </div>
    )}
  </div>
);
}*/
return (
  <div className="flex justify-center">
    <div className="w-full max-w-md bg-white shadow-md rounded-lg overflow-hidden">

      {/* Header */}
      {/*<div className="bg-blue-700 text-white px-4 py-2 font-semibold text-sm"> */}
        <div className="bg-[#1788ac] text-white px-4 py-2 font-semibold text-sm"> 
        RECENT PLANT-IN
      </div>

      {/* Body */}
      <div className="p-4 min-h-[100px] flex items-center justify-center">

        {loading && (
          <div className="text-gray-600">Loading...</div>
        )}

        {!loading && groupedData.length === 0 && (
          <div className="text-gray-500">
            No data available
          </div>
        )}

        {!loading && groupedData.length > 0 && (
          <div className="w-full">
            <div className="flex justify-between items-start">
              <div className="text-gray-800 font-medium leading-snug">
                {groupedData[0].component}
              </div>

              <div className="text-sm text-gray-600 whitespace-nowrap">
                {groupedData[0].date.toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "2-digit",
                })}
              </div>
            </div>

            <div className="text-center mt-4 text-lg font-semibold text-gray-700">
              {groupedData[0].quantity.toFixed(2)} {groupedData[0].unit}
            </div>
          </div>
        )}

      </div>

     
    </div>
  </div>
);
}